<ng-container *appLoading="recommendation$ | withLoading | async as recommendation">
  @if (parameters$ | async; as parameters) { @if (filter$ | async; as filter) { @for (warning of recommendation.warnings; track warning) {
  <app-warning [warning]="warning"></app-warning>
  }
  <span class="horizontal" *appLoading="showSpinner$ | async">
    <ul class="iconf-tabs tabs">
      <li class="tab">
        <a
          class="tab-link"
          [routerLink]="[]"
          [queryParams]="{ filter: 'summary' }"
          queryParamsHandling="merge"
          [ngClass]="{ active: filter == 'summary' }"
          >summary</a
        >
      </li>
      @if (parameters.length > 0) {
      <li class="tab">
        <a
          class="tab-link"
          [routerLink]="[]"
          [queryParams]="{ filter: 'parameters' }"
          queryParamsHandling="merge"
          [ngClass]="{ active: filter == 'parameters' }"
          >parameters ({{ parameters.length }})</a
        >
      </li>
      } @if (recommendation.pfds.length > 0) {
      <li class="tab">
        <a
          class="tab-link"
          [routerLink]="[]"
          [queryParams]="{ filter: 'PFDs' }"
          queryParamsHandling="merge"
          [ngClass]="{ active: filter == 'PFDs' }"
          >PFDs ({{ recommendation.pfds.length }})</a
        >
      </li>
      } @if (recommendation.notes.length > 0) {
      <li class="tab">
        <a
          class="tab-link"
          [routerLink]="[]"
          [queryParams]="{ filter: 'notes' }"
          queryParamsHandling="merge"
          [ngClass]="{ active: filter == 'notes' }"
          >notes ({{ recommendation.notes.length }})</a
        >
      </li>
      }
    </ul>
    <div class="buttons-align">
      <button class="iconf-btn-filled download-button" (click)="downloadNarrative()">
        <fa-icon [icon]="faFileAlt"></fa-icon>
        download narrative
      </button>
      <button class="iconf-btn-filled download-button" (click)="downloadSummary()">
        <fa-icon [icon]="faDownload"></fa-icon>
        download system summary
      </button>
    </div>
  </span>
  @if ((filter == 'summary' || filter == 'parameters') && parameters.length > 0) {
  <parameter-list [parameters]="parameters"></parameter-list>
  } @if ((filter == 'summary' || filter == 'PFDs') && recommendation.pfds.length > 0) {
  <div class="pfd-header">
    <span>PFDs ({{ recommendation.pfds.length }})</span>
    <span>
      <button class="iconf-btn-filled download-button" (click)="downloadAllPfds()">
        <fa-icon [icon]="faExternalLinkAlt"></fa-icon>
        download all pfds
      </button>
    </span>
  </div>
  <div class="pfd-container">
    @for (pfd of recommendation.pfds; track pfd) {
    <app-pfd-outline [pfd]="pfd" (downloadPfd)="downloadPfd($event)" (openPfd)="openPfd($event)"></app-pfd-outline>
    }
  </div>
  } @if ((filter == 'summary' || filter == 'notes') && recommendation.notes.length > 0) {
  <div class="note-header">Notes ({{ recommendation.notes.length }})</div>
  @for (group of groups; track group) {
  <div>
    <div class="note-subtitle">{{ group }}</div>
    <ol>
      @for (note of recommendation.notes; track note; let i = $index) { @if (note.group == group) {
      <li class="note-content">{{ i + 1 }}. {{ note.content }}</li>
      } }
    </ol>
  </div>
  } } } }
</ng-container>
